import { generateDeckOrder } from '@solante/shared';

export const shuffleDeck = (serverSeed: string, clientSeed: string, nonce: number) =>
  generateDeckOrder(serverSeed, clientSeed, nonce);
